import React, { useState } from "react";
import "./CourseDetails.css";
import { BsFillCircleFill } from "react-icons/bs";
import { motion } from "framer-motion";
// import { useParams } from "react-router";


// const containerPlaylist = {
//   hidden: {
//     opacity: 0,
//     x: "100vh",
//   },
//   hiddenleft: {
//     opacity: 0,
//     x: "-100vh",
//   },
//   visible: {
//     opacity: 1,
//     x: "0",
//     transition: {
//       type: "spring",
//       stiffness: 80,
//     },
//   },
// };

const scaleVariants ={
  whileInView:{
    scale:[0,1],
    opacity:[0,1],
    transition:{
      duration:0.7,
      ease:"easeInOut"
    }
  }
}

const CourseDetails = ({ courses, id }) => {
  // const {id} = useParams();
  const [enrollMsg, setEnrollMsg] = useState(false);
  const [enrollDone, setEnrollDone] = useState(false);
  // console.log("11", id);

  const handleEnroll = () => {
    fetch(`${process.env.REACT_APP_BASE_URL}/enroll/${id}`, {
      method: "POST",
      header: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        // console.log("555", res);
        if (res.status === "success") {
          setEnrollMsg(true);
        } else {
          setEnrollDone(true);
        }
      });
  };

  if (!courses) {
    return <div>wait</div>;
  }
  return (
    <div className="CourseDetails">
      <motion.div
        className="CourseDetails-left"
        // variants={containerPlaylist}
        // initial="hiddenleft"
        // animate="visible"
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
      >
        <div className="CourseDetails-left-top">
          <h2>Course Details</h2>
          <p>{courses.description?.text}</p>
        </div>

        <div className="CourseDetails-left-bottom">
          <h2>What You will learn</h2>
          {courses.description?.list?.map((l, index) => (
            <p key={index}>
              <span>
                <BsFillCircleFill />
              </span>{" "}
              {l}
            </p>
          ))}
        </div>
      </motion.div>
      <motion.div
        className="CourseDetails-right"
        // variants={containerPlaylist}
        // initial="hidden"
        // animate="visible"
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
      >
        <div className="CourseDetails-right-top">
          <div>
            <h2 className="CourseDetails-right-top-gray">price</h2>
            <h2 className="CourseDetails-right-top-red">{courses.price} LE</h2>
          </div>
          <div>
            <h2 className="CourseDetails-right-top-gray">Instructor</h2>
            <h2 className="CourseDetails-right-top-r">
              {courses.instructor?.first_name} {courses.instructor?.last_name}
            </h2>
          </div>
          <div>
            <h2 className="CourseDetails-right-top-gray">Lessons</h2>
            <h2 className="CourseDetails-right-top-r">
              {courses.lessons?.length}
            </h2>
          </div>
          <div>
            <h2 className="CourseDetails-right-top-gray">Quizzes</h2>
            <h2 className="CourseDetails-right-top-r">
              {courses.quizzes?.length}
            </h2>
          </div>
        </div>
        {!enrollMsg ? <span></span> : <div>Success</div>}
        {!enrollDone ? (
          <span></span>
        ) : (
          <div>You have already enrolled to this course</div>
        )}
        <motion.button
          className="but-full-width"
          whileHover={{ scale: 1.05 }}
          onClick={handleEnroll}
        >
          Enroll
        </motion.button>
      </motion.div>
    </div>
  );
};

export default CourseDetails;
